import { CircularProgress } from '@mui/material';
import styled, { css } from 'styled-components';

const FullPageWrapper = styled.div`
  background: #fff;
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: hidden;
`;

const ShowDiv = styled.div`
  ${({ show }) => {
    show
      ? css`
          display: none;
        `
      : css`
          display: block;
        `;
  }}
`;

const FullPageLoading = ({ show, children }) => {
  return (
    <>
      {show && (
        <FullPageWrapper>
          <CircularProgress
            sx={{
              '--CircularProgress-size': '120px',
              '--CircularProgress-track-color': '#F0F3F5',
              '--CircularProgress-progress-color': 'var(--mui-palette-primary-600)',
            }}
          />
        </FullPageWrapper>
      )}
      <ShowDiv show={show}>{children}</ShowDiv>
    </>
  );
};

export default FullPageLoading;
